<div class="dialog-content-wrapper tutorial-dialog-responsive">
    <div class="tutorial-dialog-header">
        <div (click)="dismissModalOnStorage();" 
        class="close-btn"
        mat-dialog-close
        aria-label="Fechar">
            <mat-icon>close</mat-icon>
    </div>
    </div>
    
    <div mat-dialog-content>
        <h1 class="text-center title-h1">
            Deixe seus orçamentos com a cara da sua empresa
        </h1>
        <h2 class="title-h2">
            Configure uma vez e use em todos os orçamentos
        </h2>

        <p class="content-p">
            Escolha o layout, adicione sua logo, ajuste as cores e preencha os dados da empresa, a descrição padrão e as condições gerais.
            Tudo isso entra automaticamente em cada orçamento que você criar. Os orçamentos são criados no menu <b>Orçamentos</b>.
        </p>
        <div style="margin: 0 auto;">
            <app-video-card
                [videoUrl]="videoUrl"
                modalTitle="Deixe seus orçamentos com a cara da sua empresa">
            </app-video-card>
        </div>
    </div>
    
    <div class="tutorial-dialog-footer">
        <button class="btn-gradient-round" 
        (click)="dismissModalOnStorage()">
            Personalizar aparência
        </button>
    </div>
</div>
